import CryptoJS from 'crypto-js';

const DEFAULT_SECRET = 'kudukey-secure-storage-fallback';
const STORAGE_SECRET = process.env.REACT_APP_STORAGE_SECRET || DEFAULT_SECRET;

const encrypt = (value) => {
  try {
    return CryptoJS.AES.encrypt(value, STORAGE_SECRET).toString();
  } catch (error) {
    console.warn('secureStorage encrypt failed', error);
    return null;
  }
};

const decrypt = (encryptedValue) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, STORAGE_SECRET);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || null;
  } catch (error) {
    console.warn('secureStorage decrypt failed', error);
    return null;
  }
};

const secureStorage = {
  setItem: (key, value) => {
    if (value === undefined || value === null) {
      localStorage.removeItem(key);
      return;
    }
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
    const encryptedValue = encrypt(stringValue);
    if (encryptedValue) {
      localStorage.setItem(key, encryptedValue);
    }
  },
  getItem: (key) => {
    const encryptedValue = localStorage.getItem(key);
    if (!encryptedValue) {
      return null;
    }
    const decryptedValue = decrypt(encryptedValue);
    if (!decryptedValue) {
      localStorage.removeItem(key);
    }
    return decryptedValue;
  },
  removeItem: (key) => {
    localStorage.removeItem(key);
  },
};

export default secureStorage;
